import React from "react";
import { useNavigate } from "react-router-dom";

import { ArrowBack } from "@libraries/icons";

import * as Styled from "./styles";

interface BackButtonProps {
  backUrl: string;
}

const BackButton: React.FC<BackButtonProps> = ({ backUrl }) => {
  const navigate = useNavigate();

  return (
    <Styled.BackButtonContainer>
      <ArrowBack onClick={() => navigate(backUrl)} fontSize="large" />
    </Styled.BackButtonContainer>
  );
};

export default BackButton;
